module.exports = __webpack_public_path__ + "img/icon_service@3x.a9cad600.png";